import { render } from "./OrderDispatchPrint.vue?vue&type=template&id=479d2a6c&scoped=true&ts=true"
import script from "./OrderDispatchPrint.vue?vue&type=script&lang=ts"
export * from "./OrderDispatchPrint.vue?vue&type=script&lang=ts"

import "./OrderDispatchPrint.vue?vue&type=style&index=0&id=479d2a6c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-479d2a6c"]])

export default __exports__